import React from "react";
import { Grid } from "@mui/material";
import LeftSideOnboarding, { LeftSideOnboardingProps } from "../LeftSideOnboarding";
import RightSideOnboarding, { RightSideOnboardingProps } from "../RightSideOnboarding";
import { OnboardingStage as OnboardingStageEnum } from "../../../util/enums";

interface OnboardingLayoutProps {
  leftSideProps: LeftSideOnboardingProps;
  rightSideProps: RightSideOnboardingProps & { activeStep: OnboardingStageEnum };
}

const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({
  leftSideProps,
  rightSideProps,
}) => {
  const { activeStep } = rightSideProps;

  const isIntroduction = activeStep === OnboardingStageEnum.INTRODUCTION;
  const isComplete = 
    activeStep === OnboardingStageEnum.COMPLETE ||
    activeStep === OnboardingStageEnum.FINISHED;
  
  const is5050Layout = isIntroduction || isComplete;
  const leftCols  = is5050Layout ? 6 : 3;
  const rightCols = is5050Layout ? 6 : 9;

  return (
    <Grid
      container
      sx={{
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Grid
        item
        xs={12}
        md={leftCols}
        sx={{
          height: "100%",
          display: { xs: "none", md: "block" },
          overflow: "hidden",
        }}
      >
        <LeftSideOnboarding {...leftSideProps} />
      </Grid>

      <Grid
        item
        xs={12}
        md={rightCols}
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <RightSideOnboarding {...rightSideProps} />
      </Grid>
    </Grid>
  );
};

export default OnboardingLayout;
